import { useNavigate } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';
import { App } from '@capacitor/app';
import { useEffect } from 'react';

import { OktaExternalAuth } from 'utils/okta/OktaExternalAuthService';
import Config from 'Config';
import { androidAppId, iosAppId } from '../capacitor.config';

const AuthRedirectListener = () => {
    const navigate = useNavigate();
    const platform = Capacitor.getPlatform();
    const isMobile = platform === 'android' || platform === 'ios';

    useEffect(() => {
        const listenForBrowserPageLoaded = async () => {
            const authService = await OktaExternalAuth.getInstance();
            const appId = platform === 'android' ? androidAppId : iosAppId;

            await App.addListener('appUrlOpen', (data: { url: string }) => {
                if (data.url.indexOf(authService.authConfig.redirect_url) === 0) {
                    const pathName = data.url.replace(`${appId}:/`, '');
                    navigate(pathName);
                }

                if (data.url.indexOf(authService.authConfig.end_session_redirect_url) === 0) {
                    navigate(Config.oktaExternalSignOutRedirectPath);
                }
            });
        };

        if (isMobile) {
            Browser.addListener('browserPageLoaded', listenForBrowserPageLoaded).catch(console.error);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps -- Only want to run once
    }, []);

    return null;
};

export default AuthRedirectListener;
